<main [@fadeInOut] id="main-heading" role="main" tabindex="0">
  <div class="col-sm-11 center-block extra-top-space" [@fadeInOut]>
    <div class="row">
      <div class="col-4 extra-top-space text-center">
        <span class="primary">
          <i class="fas fa-user-lock fa-9x"></i>
        </span>
      </div>
      <div class="col-8 extra-top-space">
        <h1 tabindex="0" aria-label="No permissions to access the page" role="heading" aria-level="1">We're sorry, but it looks like you don't have permission to access this application.</h1>

        <p tabindex="0">
          Please contact our helpdesk at <a href="tel:+12156828282" tabindex="0" aria-label="+1. 2 1 5. 6 8 2. 8 2 8 2." role="link">+1 215-682-8282</a>
          (toll free <a href="tel:+18778881559" tabindex="0" aria-label="+1. 8 7 7. 8 8 8. 1 5 5 9." role="link">+1 877-888-1559)</a>
          or email us anytime at <a href="mailto:customer.support@reedtech.com" tabindex="0" aria-label="Help Desk Email Address" role="link">Customer.Support@reedtech.com</a>.
        </p>

      </div>
    </div>
  </div>
</main>
